export default {
  items: [
    {
      name: 'Menu Principal',
      icon: 'icon-speedometer',
      children: [
        {
          name: 'Usuários',
          url: '/usuarios',
          icon: 'fa fa-users'
        },
        {
          name: 'Locais',
          url: '/locais',
          icon: 'fa fa-users'
        },
        // {
        //   name: 'Atendimentos',
        //   url: '/atendimentos',
        //   icon: 'fa fa-users'
        // },
        // {
        //   name: 'Notícias',
        //   url: '/noticias',
        //   icon: 'fa fa-newspaper-o'
        // },
        // {
        //   name: 'Rodas de Conversa',
        //   url: '/rodas-conversa',
        //   icon: 'fa fa-users'
        // },
        // {
        //   name: 'Aprenda +',
        //   url: '/conteudos',
        //   icon: 'fa fa-newspaper-o'
        // },
        {
          name: 'Cursos',
          url: '/cursos',
          icon: 'fa fa-youtube-play'
        },
        {
          name: 'Informações',
          url: '/informacoes',
          icon: 'fa fa-info'
        },
        {
          name: 'Programas de Governo',
          url: '/programas',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Municípios',
          url: '/municipios',
          icon: 'fa fa-bank'
        },
        {
          name: 'Programas do Município',
          url: '/admin/programas-municipios',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Relatórios de Encontros',
          url: '/relatorio-encontros',
          icon: 'fa fa-book'
        },
        {
          name: 'Avaliações das Beneficiárias',
          url: '/avaliar-voluntarias',
          icon: 'fa fa-star'
        },
        {
          name: 'Feedbacks',
          url: '/feedbacks',
          icon: 'fa fa-comments-o'
        },
        {
          name: 'Publicar Depoimentos',
          url: '/depoimentos',
          icon: 'fa fa-commenting-o'
        },
        {
          name: 'Gerenciar FAQ',
          url: '/faqs',
          icon: 'fa fa-question-circle'
        },
        {
          name: 'Instituições',
          url: '/instituicao',
          icon: 'fa fa-bank'
        },
        {
          name: 'Redes',
          url: '/rede',
          icon: 'fa fa-globe'
        },
        {
          name: 'Classificar Rede',
          url: '/classifica',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Gerenciar Relatórios Mensais',
          url: '/relatorio-mensal',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Gerenciar Arquivos do Menu',
          url: '/arquivos-menu',
          icon: 'fa fa-files-o'
        },
        // {
        //   name: 'Perfil',
        //   icon: 'fa fa-user-circle',
        //   children: [
        //     {
        //       name: 'Gestão de acesso',
        //       url: '/perfis',
        //       icon: 'fa fa-key'
        //     }
        //   ]
        // },
        {
          name: 'Relatórios',
          icon: 'fa fa-book',
          children: [
            {
              name: 'Dashboard',
              url: '/relatorios/dashboard',
              icon: 'fa fa-file'
            },
            // {
            //   name: 'Usuários por Situação',
            //   url: '/relatorios/usuarios-situacao',
            //   icon: 'fa fa-file'
            // },
            // {
            //   name: 'Usuários por Tipo',
            //   url: '/relatorios/usuarios-tipo',
            //   icon: 'fa fa-file'
            // },
            // {
            //   name: 'Beneficiárias vinculadas a Voluntárias',
            //   url: '/relatorios/usuarios-vinculo',
            //   icon: 'fa fa-file'
            // },
            // {
            //   name: 'Idade média das beneficiárias e voluntárias',
            //   url: '/relatorios/usuarios-idade',
            //   icon: 'fa fa-file'
            // },
            {
              name: 'Quantidade total de usuários por tipo em números',
              url: '/relatorios/usuarios-total',
              icon: 'fa fa-file'
            }
          ]
        },
        {
          name: 'Gerenciar Textos de Apresentação',
          url: '/textos',
          icon: 'fa fa-mobile'
        },
        {
          name: 'Mensagens',
          url: '/mensagens',
          icon: 'fa fa-envelope'
        }
        // {
        //   name: 'Configurações',
        //   icon: 'fa fa-cog',
        //   url: '/configuracoes'
        // }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js